var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbUnlinkAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F1D5D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#FFF4F3",
    strokeOpacity: 0.4,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.625C19.1771 22.625 19.3255 22.5651 19.4453 22.4453C19.5651 22.3255 19.625 22.1771 19.625 22C19.625 21.8229 19.5651 21.6745 19.4453 21.5547C19.3255 21.4349 19.1771 21.375 19 21.375C18.8229 21.375 18.6745 21.4349 18.5547 21.5547C18.4349 21.6745 18.375 21.8229 18.375 22C18.375 22.1771 18.4349 22.3255 18.5547 22.4453C18.6745 22.5651 18.8229 22.625 19 22.625ZM18.375 20.125H19.625V16.375H18.375V20.125ZM19 25.75C18.1354 25.75 17.3229 25.5859 16.5625 25.2578C15.8021 24.9297 15.1406 24.4844 14.5781 23.9219C14.0156 23.3594 13.5703 22.6979 13.2422 21.9375C12.9141 21.1771 12.75 20.3646 12.75 19.5C12.75 18.6354 12.9141 17.8229 13.2422 17.0625C13.5703 16.3021 14.0156 15.6406 14.5781 15.0781C15.1406 14.5156 15.8021 14.0703 16.5625 13.7422C17.3229 13.4141 18.1354 13.25 19 13.25C19.8646 13.25 20.6771 13.4141 21.4375 13.7422C22.1979 14.0703 22.8594 14.5156 23.4219 15.0781C23.9844 15.6406 24.4297 16.3021 24.7578 17.0625C25.0859 17.8229 25.25 18.6354 25.25 19.5C25.25 20.3646 25.0859 21.1771 24.7578 21.9375C24.4297 22.6979 23.9844 23.3594 23.4219 23.9219C22.8594 24.4844 22.1979 24.9297 21.4375 25.2578C20.6771 25.5859 19.8646 25.75 19 25.75Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbUnlinkAlertIcon);
export default __webpack_public_path__ + "static/media/fb-unlink-alert-icon.cf702fef582894a5ed9266570074fbb9.svg";
export { ForwardRef as ReactComponent };